/**
 * Centralized color palette for the Digital Twin visualization.
 *
 * Uses Vortx brand + chart colors so each equipment type is instantly
 * recognizable. All twin components import from here.
 */

// ── Per-equipment colors (from chartColors in theme.js) ────────────
export const SOLAR_PRIMARY = '#ffaa00';      // Orange — PV generation
export const SOLAR_DIM = '#996600';
export const SOLAR_GLOW = '#ffcc44';

export const BATTERY_PRIMARY = '#aa88ff';    // Purple — BESS
export const BATTERY_DIM = '#5544aa';
export const BATTERY_GLOW = '#ccaaff';
export const BATTERY_LOW = '#443366';
export const BATTERY_MID = '#7766cc';

export const EV_PRIMARY = '#00d4aa';         // Teal — EV charging
export const EV_DIM = '#006655';
export const EV_GLOW = '#44ffcc';

export const COLD_PRIMARY = '#7B68EE';       // Medium purple — HVAC/cold
export const COLD_DIM = '#3d3477';
export const COLD_GLOW = '#9988ff';
export const COLD_FROST = '#aabbff';

export const GRID_PRIMARY = '#4488cc';       // Steel blue — Grid
export const GRID_DIM = '#1A3A5C';
export const GRID_IMPORT = '#66aaff';
export const GRID_EXPORT = '#88ff44';        // Lime — export

export const BUILDING_PRIMARY = '#a6a19b';   // Stone — building structure
export const BUILDING_DIM = '#5c5957';
export const BUILDING_WINDOW = '#ffcc66';    // Warm glow for windows
export const BUILDING_DIVIDER = '#6b6660';

// ── Flow colors (energy conduits) — match source equipment ─────────
export const FLOW_SOLAR = SOLAR_PRIMARY;
export const FLOW_GRID = GRID_IMPORT;
export const FLOW_BATTERY = BATTERY_PRIMARY;
export const FLOW_DEFAULT = '#b28c50';       // Gold fallback

// ── Labels — Vortx brand ──────────────────────────────────────────
export const LABEL_TEXT = '#f4f1ec';          // White — main text
export const LABEL_ACCENT = '#b28c50';       // Gold — equipment names
export const LABEL_DIM = '#a6a19b';          // Stone — secondary text
export const LABEL_BG = '#1a1a1a';           // Dark bg (retro mode)
export const LABEL_BG_LIGHT = '#f5f5f5';     // Light bg (light mode)
export const STATUS_ON = '#5fd4c4';          // Retro teal — active
export const STATUS_OFF = '#444';            // Gray — inactive

// ── Scene lighting ─────────────────────────────────────────────────
export const AMBIENT_COLOR = '#334455';
export const KEY_LIGHT_COLOR = '#88aacc';
export const FILL_LIGHT_COLOR = '#445566';

// ── Ground ─────────────────────────────────────────────────────────
export const GROUND_BASE = '#111a1a';
export const GROUND_GLOW = '#3f6a64';        // Teal glow near equipment

// ── Terrain ────────────────────────────────────────────────────────
export const TERRAIN_PARTICLE = '#3f6a64';
export const TERRAIN_DIM = '#1a2a28';

// ── Wire ───────────────────────────────────────────────────────────
export const WIRE_DIM = '#334455';

// ── Legacy aliases (for any imports not yet updated) ───────────────
export const DEEP_BLUE = GRID_DIM;
export const ACTIVE_BLUE = '#5fd4c4';
export const ACCENT_BLUE = '#5fd4c4';
export const FROST_BLUE = COLD_PRIMARY;
export const MEDIUM_BLUE = SOLAR_DIM;
export const DIM_BLUE = '#1a2a28';
export const DARK_BLUE = '#222';
export const NEAR_BLACK = '#111';
export const IMPORT_BLUE = GRID_IMPORT;
export const EXPORT_CYAN = GRID_EXPORT;
export const METRIC_BLUE = '#5fd4c4';
export const CHARGE_BLUE = BATTERY_PRIMARY;
export const LOW_BLUE = BATTERY_LOW;
export const MID_BLUE = BATTERY_MID;
export const WINDOW_BLUE = BUILDING_WINDOW;
export const DIVIDER_BLUE = BUILDING_DIVIDER;
export const FROST_PARTICLE = COLD_FROST;
export const GROUND_GLOW_LEGACY = GROUND_GLOW;
